import React from 'react';

import {getModelPaperLink, STRUCTURE_PREDICTION_MODEL} from 'molbio/proteins/util/StructurePredictionModels';

export function AlphaFoldPaperLink(): JSX.Element {
  return (
    <a
      href={getModelPaperLink(STRUCTURE_PREDICTION_MODEL.ALPHAFOLD)}
      target="_blank"
      rel="noopener noreferrer"
    >
      AlphaFold2
    </a>
  );
}
